import React from "react";
import { tableRowNavigation } from '../../helpers/TableRowNavigation';
import { connect } from "react-redux";
import {IconButton} from "@material-ui/core";
import {apiCall} from "../../helpers/MainHelper";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
import {withRouter} from "react-router-dom";

class BankAccountsListTable extends React.Component {

  handleDelete = async (accountID) => {
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall('business/settings/bank-account-delete/'+accountID,'delete',null)
          await this.props.fetchQrs();
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
            'Silindi!',
            'Banka hesabı başarıyla silindi.',
            'success'
        );
      } else {
        Swal.fire(
            'Hata!',
            'Silme işlemi başarısız oldu.',
            'error'
        );
      }
    }
  }
  handleAccountDetail = (accountId) => {
    this.props.history.push(`/bank-account-detail/${accountId}`);
  }
  render() {
    const { bodyData } = this.props;

    return (

        <div className="table-responsive">
          <table className="table m-b-0 table-hover">
            <thead className="thead-light">
            <tr>
              <th>ID</th>
              <th>Banka Adı</th>
              <th>Banka Şube</th>
              <th>Hesap No</th>
              <th>İban No</th>
              <th>Şube</th>
              <th>İşlemler</th>
            </tr>
            </thead>
            <tbody>
            {bodyData.length > 0 ? (
                bodyData.map((data, i) => {
                  return (
                      <tr {...tableRowNavigation(() => this.handleAccountDetail(data.id))} key={"dihf" + i}>
                        <td>
                          {data.id}
                        </td>
                        <td>
                          {data.name}
                        </td>
                        <td>
                          {data.bank_branch}
                        </td>
                        <td>
                          {data.account_no}
                        </td>
                        <td>
                          {data.iban}
                        </td>
                        <td>
                          {data.branch.name}
                        </td>

                        <td className="project-title">

                          <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(data.id)}
                                      style={{cursor: 'pointer', marginLeft: -15}}>
                            <button type="button" className="btn btn-outline-danger btn-sm"><i
                                className="icon-trash"></i></button>
                          </IconButton>
                        </td>
                      </tr>
                  );
                })
            ) : (
                <tr className="text-center">
                  <td colSpan="7">
                    <div className="alert alert-warning mb-0">
                      Hesap Bulunamadı!
                    </div>
                  </td>
                </tr>
            )}
            </tbody>
          </table>
        </div>

    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(BankAccountsListTable));
